module.exports = __webpack_public_path__ + "static/media/not-serious_600.e870c8ba.jpg";